import { render, staticRenderFns } from "./RecommendationTable.vue?vue&type=template&id=e3efa98e&scoped=true&"
import script from "./RecommendationTable.vue?vue&type=script&lang=js&"
export * from "./RecommendationTable.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationTable.vue?vue&type=style&index=0&id=e3efa98e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3efa98e",
  null
  
)

export default component.exports